/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OWEventTypeResponse
 */
export interface OWEventTypeResponse {
    /**
     * The name of the event type (e.g., "KILL", "DEATH")
     * @type {string}
     * @memberof OWEventTypeResponse
     */
    name: string;
    /**
     * The structure/schema of the event data
     * @type {object}
     * @memberof OWEventTypeResponse
     */
    dataStructure: object;
    /**
     * Whether the event data must match the dataStructure exactly or partially
     * @type {boolean}
     * @memberof OWEventTypeResponse
     */
    partialMatch: boolean;
    /**
     * The ID of the game this event type is associated with
     * @type {string}
     * @memberof OWEventTypeResponse
     */
    game?: string;
    /**
     * id of the event type
     * @type {string}
     * @memberof OWEventTypeResponse
     */
    id: string;
    /**
     * Timestamp when the event type was created
     * @type {number}
     * @memberof OWEventTypeResponse
     */
    createdAt: number;
    /**
     * Timestamp when the event type was last updated
     * @type {number}
     * @memberof OWEventTypeResponse
     */
    updatedAt: number;
}

/**
 * Check if a given object implements the OWEventTypeResponse interface.
 */
export function instanceOfOWEventTypeResponse(value: object): value is OWEventTypeResponse {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('dataStructure' in value) || value['dataStructure'] === undefined) return false;
    if (!('partialMatch' in value) || value['partialMatch'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function OWEventTypeResponseFromJSON(json: any): OWEventTypeResponse {
    return OWEventTypeResponseFromJSONTyped(json, false);
}

export function OWEventTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWEventTypeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'dataStructure': json['dataStructure'],
        'partialMatch': json['partialMatch'],
        'game': json['game'] == null ? undefined : json['game'],
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function OWEventTypeResponseToJSON(json: any): OWEventTypeResponse {
    return OWEventTypeResponseToJSONTyped(json, false);
}

export function OWEventTypeResponseToJSONTyped(value?: OWEventTypeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'dataStructure': value['dataStructure'],
        'partialMatch': value['partialMatch'],
        'game': value['game'],
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

